/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Market_Signals_DescInputs */

const en_directory_launch_market_signals_desc = /** @type {(inputs: Directory_Launch_Market_Signals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's trending this month.`)
};

const zh_directory_launch_market_signals_desc = /** @type {(inputs: Directory_Launch_Market_Signals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月正在升温的方向。`)
};

/**
* | output |
* | --- |
* | "What's trending this month." |
*
* @param {Directory_Launch_Market_Signals_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_market_signals_desc = /** @type {((inputs?: Directory_Launch_Market_Signals_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Market_Signals_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_market_signals_desc(inputs)
	return zh_directory_launch_market_signals_desc(inputs)
});
export { directory_launch_market_signals_desc as "directory.launch.market_signals_desc" }